import React, { FC } from 'react';
import config from '../../appConfig';

const LimitedAccess: FC = () => {
  const appgalleryUrl = `${config.universeFrontendUrl}/appgallery`;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Limited Access</h1>
      <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>Your access to this product is currently limited.</p>
      <p style={{ fontSize: '1rem', color: '#666' }}>
        If you believe this is a mistake or need access, please contact the administrator. Or you can visit{' '}
        <a href={appgalleryUrl} style={{ color: '#007bff', textDecoration: 'none' }}>
          App Gallery
        </a>{' '}
        to explore our products.
      </p>
    </div>
  );
};

export default LimitedAccess;
